
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var RecruitApplyPage = Vue.extend({})
Vue.component('recruitApply-page', RecruitApplyPage)

export default {
  name: 'RecruitApplyPage',
  components: {
    XTable
  },
  props: {

  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      flowId: ''
    }
  },
  mounted () {
    // this.$emit('sendTitleToParent','借款申请');
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/recruitApply.vue